import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { MtnaDataType } from '@mtna/data-core-ui';

import { RdsDataTypeUtil } from '../utils/data-type-util';

@Pipe({
  name: 'rdsSimplifyDataType',
})
export class RdsSimplifyDataTypePipe implements PipeTransform {
  transform(value: MtnaDataType): Extract<MtnaDataType, 'DATE' | 'NUMERIC' | 'TEXT'> {
    return RdsDataTypeUtil.simplifyMtnaDataType(value);
  }
}

@NgModule({
  declarations: [RdsSimplifyDataTypePipe],
  exports: [RdsSimplifyDataTypePipe],
})
export class RdsSimplifyDataTypePipeModule {}
